import { useQuery } from '@tanstack/react-query';
import { ApplicationAPI, ApplicationFilterOptions, FindApplicationsOptions } from '../api';

export const useApplicationById = (applicationId?: number) => {
  return useQuery({
    queryKey: ['application', applicationId],
    queryFn: () => ApplicationAPI.getById(applicationId!),
    select: (data) => data.data,
    enabled: !!applicationId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};


export const useApplicationProjects = (applicationId: number) => {
  return useQuery({
    queryKey: ['application', applicationId, 'projects'],
    queryFn: () => ApplicationAPI.getProjects(applicationId!),
    select: (data) => data.data,
    enabled: !!applicationId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};


export const useApplicationComponents = (applicationId: number) => {
  return useQuery({
    queryKey: ['application', 'components', applicationId],
    queryFn: () => ApplicationAPI.getAllComponents(applicationId),
    select: (data) => data.data,

  });
};

export const useApplications = (options?: FindApplicationsOptions) => {
  return useQuery({
    queryKey: ['applications', options],
    queryFn: () => ApplicationAPI.getAll(options),
    select: (data) => data.data,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useApplicationsList = (workgroupId?: number) => {
  return useQuery({
    queryKey: ['applications', 'list', workgroupId],
    queryFn: () => ApplicationAPI.getList(),
    select: (data) => data.data,
    enabled: !!workgroupId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};